import React from 'react';
import { PlusCircleIcon } from '@heroicons/react/24/outline';

const Logo = ({ size = 'default', centered = false, minimal = false }) => {
  const sizeClasses = {
    'small': 'text-sm',
    'default': 'text-base',
    'large': 'text-lg'
  };

  if (minimal) {
    return (
      <div className={`flex items-center ${centered ? 'justify-center' : ''}`}>
        <svg className="w-8 h-8 flex-shrink-0" viewBox="0 0 24 24" fill="none">
          <circle
            cx="12"
            cy="12"
            r="5"
            className="stroke-gray-400 group-hover:stroke-gray-200 transition-colors duration-300"
            strokeWidth="2"
            transform="translate(-3, 0)"
          />
          <circle
            cx="12"
            cy="12"
            r="5"
            className="stroke-gray-400 group-hover:stroke-gray-200 transition-colors duration-300"
            strokeWidth="2"
            transform="translate(3, 0)"
          />
        </svg>
      </div>
    );
  }

  const content = (
    <div className={`flex items-center ${centered ? 'justify-center' : ''}`}>
      <svg className="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24" fill="none">
        <circle
          cx="12"
          cy="12"
          r="5"
          className="stroke-gray-400 group-hover:stroke-gray-200 transition-colors duration-300"
          strokeWidth="2"
          transform="translate(-3, 0)"
        />
        <circle
          cx="12"
          cy="12"
          r="5"
          className="stroke-gray-400 group-hover:stroke-gray-200 transition-colors duration-300"
          strokeWidth="2"
          transform="translate(3, 0)"
        />
      </svg>
      <h1 className={`ml-2 font-medium text-white ${sizeClasses[size] || sizeClasses.default}`}>
        Content Hub
      </h1>
    </div>
  );

  return centered ? (
    <div className="flex justify-center w-full">
      {content}
    </div>
  ) : content;
};

export default Logo; 